import { Component } from '@opten/compiler/metadata/component';
import { memberStorage, accountService } from '../shop/shop-context';
import { canWrite, canAccessApp } from '../models/roles';
import addClass from '@opten/dom/add-class';
import removeClass from '@opten/dom/remove-class';
import { User } from '../models/customer';
import { catchError } from 'rxjs/operators';
import { empty, of } from 'rxjs';

@Component({ className: 'js-request-additional-roles' })
export class RequestRoles {
	private customerId: HTMLInputElement;
	private user: User;
	private options: HTMLInputElement[];
	private successMessage: any;
	private errorMessage: any;

	constructor(private form: HTMLFormElement) {
		this.options = Array.from(this.form.querySelectorAll('input[type="checkbox"]')) as HTMLInputElement[];
		this.customerId = this.form.querySelector('#partnerId') as HTMLInputElement;

		this.successMessage = this.form.querySelector('#request-message-success');
		this.errorMessage = this.form.querySelector('#request-message-error');

		accountService.get().subscribe(user => {
			this.user = user;
			this.checkAlreadyAddedRoles(user);
		});

		this.form.addEventListener('submit', e => this.submit(e));
	}

	private onChange(opt: HTMLInputElement) {
		if (
			opt.value === 'Website:Shop' &&
			((this.user.contractualPartner && this.user.contractualPartner.id <= 0) || this.user.customerId <= 0)
		) {
			opt.checked ? removeClass(this.customerId.parentElement, 'd-none') : addClass(this.customerId.parentElement, 'd-none');
		}
	}

	private checkAlreadyAddedRoles(user: User) {
		this.options.forEach((opt: HTMLInputElement) => {
			opt.checked = opt.value === 'GG:Connect' ? canAccessApp(user) : canWrite({ authorizations: [opt.value] }, user);
			opt.disabled = opt.checked;
			opt.addEventListener('change', () => this.onChange(opt as HTMLInputElement));
		});
	}

	private submit(event: Event) {
		event.preventDefault();
		addClass(this.successMessage, 'd-none');
		addClass(this.errorMessage, 'd-none');

		accountService
			.requestRoles(
				this.options.filter(o => o.checked).map(o => o.value),
				+this.customerId.value
			)
			.pipe(
				catchError(err => {
					addClass(this.form.querySelector('#request-message-success'), 'd-none');
					removeClass(this.form.querySelector('#request-message-error'), 'd-none');
					return of(null);
				})
			)
			.subscribe((user: User) => {
				if (user) {
					this.checkAlreadyAddedRoles(user);
					removeClass(this.form.querySelector('#request-message-success'), 'd-none');
					addClass(this.form.querySelector('#request-message-error'), 'd-none');
				}
			});
	}
}
